import { Component, OnInit } from '@angular/core';
import { ModalController} from '@ionic/angular';
import { ContactsImportPage } from '../contacts-import/contacts-import.page';

import { Capacitor } from '@capacitor/core';

import { UntypedFormGroup, UntypedFormBuilder, Validators } from "@angular/forms";

import { Contact } from '../models/contact';
import { Property } from '../models/property';
import { ApiService } from '../services/api.service';
import { TitleService } from '../titles/title.service';
import { ToastService } from '../shared/toast.service';

import { Router } from '@angular/router';

@Component({
  selector: 'app-contacts-create',
  templateUrl: './contacts-create.page.html',
  styleUrls: ['./contacts-create.page.scss'],
})
export class ContactsCreatePage implements OnInit {

  isNativePlatform = true;
  ionicForm: UntypedFormGroup;
  isSubmitted = false;
  titles: string[]

  constructor(
    public modalCtrl: ModalController, 
    public formBuilder: UntypedFormBuilder, 
    public apiService: ApiService, 
    public router: Router, 
    private titleService: TitleService,
    private toastService: ToastService) {
      this.titles = this.titleService.getTitles();
  }

  ngOnInit() {
    this.isNativePlatform = Capacitor.isNativePlatform();

    // Build Contact Form
    this.ionicForm = this.formBuilder.group({
      isBusiness: false,
      title: [''],
      business_name: [''],
      first_name: ['', [Validators.required, Validators.minLength(2)]],
      last_name: ['', [Validators.minLength(2)]],
      email: ['', [Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$')]],
      // phone1: ['', [Validators.pattern('^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$')]],
      // phone2: ['', [Validators.pattern('^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$')]],
      phone1: [''],
      phone2: [''],
      address1: [''],
      address2: [''],
      city: [''],
      postcode: [''],
      notes: ['']
    })
  }

  dismiss() {  
    this.modalCtrl.dismiss();
  }

  private prepareSave(): Contact {
    return new Contact().deserialize(this.ionicForm.value);
  }

  submitForm() {
    this.isSubmitted = true;

    if (!this.ionicForm.valid) {
      console.log('Please provide all the required values for a contact.')
      return false;
    } else {

      // Save contact information
      const newContact = this.prepareSave(); // `newContact` is now an instance of "Contact"

      // API Call
      this.apiService.createContact(newContact).subscribe((contact) => {
        
        if (newContact.address1) {
          // We should create a property for contact for visits
          var prop = new Property().deserialize(newContact);

          // Set ContactID for Property
          prop.contactId = contact.id;
          
          // API
          this.apiService.createProperty(prop).subscribe((response) => {
            // View Contact
            //this.router.navigateByUrl('/t/contacts/view/'+contact.id);
            this.modalCtrl.dismiss(contact); 
          });
        }
        else {
          //this.router.navigateByUrl('/t/contacts/view/'+contact.id);
          // Toast with link to view contact
          this.toastService.showToastWithContactLink('Contact created successfully', 'success', ""+contact.id);
          this.modalCtrl.dismiss(contact); 
        }
        
      });

      // Close the modal
      //this.modalCtrl.dismiss(this.ionicForm.value); 
    }
  }

  get errorControl() {
    return this.ionicForm.controls;
  }

  async showImportModal() {  
    const modal = await this.modalCtrl.create({  
      component: ContactsImportPage,
      canDismiss: true,
      presentingElement: await this.modalCtrl.getTop() // Get the top-most ion-modal
    });
    modal.onDidDismiss()
      .then((data) => {

        const contact = data.data;

        if (contact != null) {
          // We can pre-populate some form elements
          console.log('Pre-populate '+contact.name.display);
          console.log(contact);

          // Name
          this.ionicForm.patchValue(
            {
              first_name: contact.name.given,
              last_name: contact.name.family
            }
          );

          // Email Address
          if (contact.emails && contact.emails.length > 0) {
            this.ionicForm.patchValue({ email: contact.emails[0].address });
          }

          // Phone Numbers
          if (contact.phones && contact.phones.length > 0) {
              this.ionicForm.patchValue({ phone1: contact.phones[0].number || '' });
              if (contact.phones.length > 1) {
                  this.ionicForm.patchValue({ phone2: contact.phones[1].number || '' });
              }
          }

          // Spin throuh the contact's addresses looking for one with isPrimary = true (if its set, otherwise pick first address)
          // If we find one, we can pre-populate the address
          if (contact.postalAddresses && contact.postalAddresses.length > 0) {
            let primaryAddressFound = false;
            for (let i = 0; i < contact.postalAddresses.length; i++) {
                if (contact.postalAddresses[i].isPrimary) {
                  this.ionicForm.patchValue(
                    { 
                        address1: contact.postalAddresses[i].street || '',
                        //address2: contact.postalAddresses[i].neighbourhood || '',
                        city: contact.postalAddresses[i].city || '',
                        postcode: contact.postalAddresses[i].postcode || ''
                    }
                  );
                  primaryAddressFound = true;
                  break;
                }
            }
            if (!primaryAddressFound) {
              // If we didn't find a primary address, just use the first one
              this.ionicForm.patchValue(
                { 
                    address1: contact.postalAddresses[0].street || '',
                    //address2: contact.postalAddresses[0].neighbourhood || '',
                    city: contact.postalAddresses[0].city || '',
                    postcode: contact.postalAddresses[0].postcode || ''
                }
              );
            }
          }
        }
    });
    return await modal.present();
  }  

}